export default defineAppConfig({
  beacon: {
    scriptSrc: 'https://beacon-v2.helpscout.net',
  },
  alma: {
    merchantId: 'merchant_123JXDP1v5d7mcG8FDJ7Bqg246lEF3nGlt',
  },
  krypton: {
    versionUrl: 'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/version.json',
    scriptSrc:
      'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js',
    cssHref: 'https://static-sogecommerce.societegenerale.eu/static/js/krypton-client/V4.0/ext/no-theme.min.css',
    postUrlSuccess: 'pending',
  },
});
